import { Platform } from 'react-native';
import { useLocale } from '../contexts/LocaleContext';
import { typography } from '../theme/typography';
import { fonts } from '../utils/fonts';

/**
 * Returns the typography object with fontFamily values swapped to the
 * locale-appropriate font (RH for Arabic, Panton for English).
 * Use this instead of importing typography directly in components.
 */
export function useTypography() {
  const { fontFamily } = useLocale();
  const isNative = Platform.OS !== 'web';

  // Latin font set — always Panton regardless of locale.
  // Use for inputs that expect English content (email, phone, reference, etc.)
  const latinFontFamily = {
    thin:     isNative ? fonts.panton.regular  : typography.fontFamily.primary,
    primary:  isNative ? fonts.panton.regular  : typography.fontFamily.primary,
    medium:   isNative ? fonts.panton.medium   : typography.fontFamily.medium,
    semibold: isNative ? fonts.panton.semibold : typography.fontFamily.semibold,
    bold:     isNative ? fonts.panton.bold     : typography.fontFamily.bold,
    black:    isNative ? fonts.panton.black    : typography.fontFamily.black,
  };

  return {
    ...typography,
    fontFamily: {
      ...typography.fontFamily,
      // Override the active-weight keys with locale-correct fonts
      thin:     fontFamily.thin,
      primary:  fontFamily.primary,
      regular:  fontFamily.primary,
      heading:  fontFamily.bold,
      medium:   fontFamily.medium,
      semibold: fontFamily.semibold,
      bold:     fontFamily.bold,
      black:    fontFamily.black,
    },
    // Always-Latin font set for fields that expect English input
    latinFontFamily,
  };
}
